import { render, staticRenderFns } from "./allotSec.vue?vue&type=template&id=c9a29e64&scoped=true&"
import script from "./allotSec.vue?vue&type=script&lang=js&"
export * from "./allotSec.vue?vue&type=script&lang=js&"
import style0 from "./allotSec.vue?vue&type=style&index=0&id=c9a29e64&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a29e64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9a29e64')) {
      api.createRecord('c9a29e64', component.options)
    } else {
      api.reload('c9a29e64', component.options)
    }
    module.hot.accept("./allotSec.vue?vue&type=template&id=c9a29e64&scoped=true&", function () {
      api.rerender('c9a29e64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/commission/allot/allotSec.vue"
export default component.exports